import { ErrorWithFields as e } from "./error-with-fields.mjs";
//#region src/errors/conflict-error.ts
var t = class extends e {};
//#endregion
export { t as ConflictError };
